import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import { useApp } from '../../contexts/AppContext';

export default function EditUserModal({ isOpen, onClose, user }) {
  const { updateUser } = useApp();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('user');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setUsername(user.username || '');
      setRole(user.role || 'user');
      setPassword('');
    }
  }, [user]);

  const resetForm = () => {
    if (user) {
      setUsername(user.username || '');
      setRole(user.role || 'user');
    } else {
      setUsername('');
      setRole('user');
    }
    setPassword('');
    setError('');
  };

  const handleSubmit = async () => {
    if (!username) {
      setError('Username is required');
      return;
    }

    setError('');
    setLoading(true);

    try {
      const updates = {};
      if (username !== user.username) {
        updates.username = username;
      }
      if (password) {
        updates.password = password;
      }
      if (role !== user.role) {
        updates.role = role;
      }
      
      await updateUser(user.uuid, updates);
      resetForm();
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to update user');
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <>
      <button 
        className="btn btn-secondary" 
        type="button" 
        onClick={() => { resetForm(); onClose(); }}
        disabled={loading}
      >
        Cancel
      </button>
      <button 
        className="btn btn-primary" 
        type="button" 
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? 'Updating...' : 'Update User'}
      </button>
    </>
  );

  if (!user) return null;

  return (
    <Modal isOpen={isOpen} onClose={() => { resetForm(); onClose(); }} title="Edit User" footer={footer}>
      {error && <div className="form-error" style={{ marginBottom: '1rem' }}>{error}</div>}
      <div className="form-group-modal">
        <label htmlFor="edit-username">Username *</label>
        <input
          id="edit-username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter username"
          autoComplete="username"
          disabled={loading}
        />
      </div>
      <div className="form-group-modal">
        <label htmlFor="edit-password">New Password (leave blank to keep current)</label>
        <input
          id="edit-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter new password"
          autoComplete="new-password"
          disabled={loading}
        />
      </div>
      <div className="form-group-modal">
        <label htmlFor="edit-role">Role *</label>
        <select 
          id="edit-role" 
          value={role} 
          onChange={(e) => setRole(e.target.value)}
          disabled={loading}
        >
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>
      </div>
    </Modal>
  );
}

